import { useState } from "react";
import ApiFetch from "../../services/api.fetch";
import { URLS } from "../../utils/url";

export const usePayment = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    message: "",
    status: false,
  });

  const createPayment = async (userId: number) => {
    const payload = {
      userId: userId, 
      payerType: "TENANT",
      description: "Order #" + userId,
    };
    try {
      setLoading(true);
      const response = await ApiFetch.httpPostPublic(
        URLS.post.payment.createPaymentIntent,
        payload
      );
      const paymentResponseObject = JSON.parse(response?.molliePaymentResponse);
      setLoading(false);
      window.location.href = paymentResponseObject?._links.checkout.href;
    } catch (err) {
      setLoading(false);
      setError({
        message: "Payment failed, please try again.",
        status: true,
      });
      console.error("Something went wrong:", err);
    }
  };
  const values = {
    createPayment,
    loading,
    error,
  };

  return values;
};
